<template>
	<div class="group/card">
		<img v-if="rawThumbnail && !imageError" :src="rawThumbnail" @error="imageError = true" class="hidden" aria-hidden="true" alt="" />
		<img v-if="rawSecondImage && !secondImageError" :src="rawSecondImage" @error="secondImageError = true" class="hidden" aria-hidden="true" alt="" />
		<div v-if="product.wasPrice && product.wasPrice > product.currentPrice" class="cursor-pointer relative z-10 flex w-full justify-start translate-y-2.5 translate-x-2.5">
			<div class="bg-ihh-salmon p-1.5 rounded-md absolute shadow">
				<div class="flex w-full px-3 text-center text-sm text-ihh-brown font-semibold">Sale</div>
			</div>
		</div>

		<div
			v-if="!birthKit && !store.editingKit?.id && showsAsOutOfStock"
			class="cursor-pointer relative z-10 flex w-full justify-start translate-y-2.5 translate-x-2.5"
		>
			<div class="bg-ihh-coral p-1.5 rounded-md absolute shadow">
				<div class="flex w-full px-3 text-center text-sm text-ihh-white font-semibold">Out of Stock</div>
			</div>
		</div>

		<div class="cursor-pointer relative z-10 flex w-full justify-end translate-y-2.5 -translate-x-2.5">
			<!-- <div class="gradient p-1.5 rounded-md absolute shadow">
                <img v-if="wishlist" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nGNgoBFoY2Bg+MnAwPAfSreQasBPBgYGISgbRP8gRtN/EjBFhuAF/5EUYaNHDWAYCmHwk0AaIJgiW/EYQlaeoD0AAJvjVLO1j3diAAAAAElFTkSuQmCC">
                <img v-else src="/images/ob-heart-0129.svg" class="w-6 h-6" />
            </div> -->
			<div v-if="!publicList" class="gradient p-1.5 rounded-md absolute shadow">
				<button type="button" @click.stop="removeListItem" v-if="wishlist" class="p-0 border-none bg-transparent flex" aria-label="Remove from list" title="Remove from list">
					<img
						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nGNgoBFoY2Bg+MnAwPAfSreQasBPBgYGISgbRP8gRtN/EjBFhuAF/5EUYaNHDWAYCmHwk0AaIJgiW/EYQlaeoD0AAJvjVLO1j3diAAAAAElFTkSuQmCC"
						alt=""
					/>
				</button>
				<button type="button" @click.stop="addListItem" v-else class="p-0 border-none bg-transparent flex" aria-label="Add to wish list" title="Add to wish list">
					<img src="/images/ob-heart-0129.svg" class="w-6 h-6" alt="" />
				</button>
			</div>
		</div>

		<div
			class="relative group cursor-pointer flex w-full aspect-square justify-center bg-magnolia-50/60 shadow rounded-xl items-center lg:p-6 overflow-hidden product-card"
		>
			<router-link :to="url" class="block w-full">
				<!-- Updated link to include ID -->
				<!-- <img class="w-full object-center object-cover mix-blend-darken" :src="product?.images?.[0]?.url" alt="product images" /> -->
				<div class="relative w-full aspect-square">
					<div
						:style="`background-image: url(${thumbnail})`"
						class="absolute inset-0 group-hover:opacity-0 w-full bg-center bg-contain bg-no-repeat aspect-square mix-blend-darken rounded-lg"
					/>
					<div
						:style="`background-image: url(${secondImage || thumbnail})`"
						class="absolute inset-0 opacity-0 group-hover:opacity-100 w-full bg-center bg-contain bg-no-repeat aspect-square mix-blend-darken rounded-lg"
					/>
				</div>

				<div v-if="inKitQuantity" class="w-full max-w-48 absolute bottom-8 inset-x-0 px-4 mx-auto">
					<div class="flex bg-ihh-dark-salmon rounded-full justify-between items-center px-2 text-white font-semibold">
						<button @click.stop.prevent="removeFromKit" class="rounded-full aspect-square w-8 h-8 hover:bg-ihh-salmon/50 shrink-0">-</button>
						<div class="text-sm md:text-base py-3 flex w-full justify-center text-center">
							{{ inKitQuantity }}
						</div>
						<button @click.stop.prevent="addToKit(false)" class="rounded-full aspect-square w-8 h-8 bg-ihh-salmon/50 hover:bg-ihh-salmon/80 shrink-0">+</button>
					</div>
				</div>

				<div
					class="absolute flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
					:class="!small ? 'inset-0' : 'bottom-0 left-0 w-full'"
					v-else-if="store.editingKit?.id && variants?.length <= 1 && !birthKit"
				>
					<button
						class="font-medium text-sm md:text-base text-ihh-midnight-gray py-3 flex w-full justify-center text-center rounded-lg tracking-wide transition transform ease-in-out bg-ihh-dark-salmon hover:bg-ihh-salmon"
						:class="!small ? 'group-hover:-translate-y-10 mx-4' : 'w-full'"
						@click.stop.prevent="addToKit(false)"
					>
						Add to Kit
					</button>
				</div>

				<div v-else-if="inCartQuantity" class="w-full max-w-48 absolute bottom-8 inset-x-0 px-4 mx-auto">
					<div class="flex bg-ihh-dark-salmon rounded-full justify-between items-center px-2 text-white font-semibold">
						<button @click.prevent="removeFromBag" class="rounded-full aspect-square w-8 h-8 hover:bg-ihh-salmon/50 shrink-0">-</button>
						<div class="text-sm md:text-base py-3 flex w-full justify-center text-center">
							{{ inCartQuantity }}
						</div>
						<button @click.prevent="addToBag" class="rounded-full aspect-square w-8 h-8 bg-ihh-salmon/50 hover:bg-ihh-salmon/80 shrink-0">+</button>
					</div>
				</div>

				<div
					class="absolute flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
					:class="!small ? 'inset-0' : 'bottom-0 left-0 w-full'"
					v-else-if="!birthKit"
				>
					<button
						class="font-medium text-sm md:text-base text-ihh-midnight-gray py-3 flex w-full justify-center text-center rounded-lg tracking-wide transition transform ease-in-out"
						:class="addToCartButtonClasses"
						@click.prevent="handleProductAction(true)"
						:aria-disabled="showsAsOutOfStock && !birthKit && !store.editingKit?.id"
					>
						<span v-safe-html="addToCartButtonLabel"></span>
					</button>
				</div>
				<div v-if="birthKit" class="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition duration-300 rounded-lg pointer-events-none"></div>
			</router-link>
		</div>
		<div class="my-4">
			<div class="flex w-full px-2 sm:pb-0 text-sm flex-col" :class="!small ? 'md:text-base md:flex-row' : ''">
				<router-link
					:to="url"
					class="text-center md:text-start font-semibold tracking-wide text-ihh-midnight-gray break-words md:mr-2 leading-tight"
					:class="{ 'line-clamp-2': clampName2, 'line-clamp-4': clampName4, 'group-hover/card:underline': birthKit }"
					>{{ product.name }}</router-link
				>
				<div v-if="!birthKit && !hidePrice && !isPriceHidden" class="justify-end w-full">
					<template v-if="product.wasPrice">
						<div class="flex w-full justify-end text-ihh-slate-gray font-normal tracking-wide text-center md:text-end text-sm">Was:</div>
						<div
							class="text-ihh-midnight-gray font-normal tracking-wide text-center md:text-end"
							:class="product.wasPrice ? 'line-through text-ihh-gray/75 text-sm' : ''"
						>
							${{ product.wasPrice }}
						</div>
					</template>
					<div
						v-if="displayPrice != null"
						class="flex w-full text-ihh-midnight-gray font-normal tracking-wide text-center md:text-end"
						:class="!small ? 'justify-end' : 'mt-2'"
					>
						{{ displayPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
					</div>
				</div>
			</div>
			<div v-if="!hideReviews" class="flex w-full justify-center md:justify-start px-2">
				<div class="flex" v-if="product.rating">
					<Stars :stars="product.rating" class="w-full max-w-[5rem] mr-2" />
					<div class="text-xs text-ihh-gray-600 m-auto flex w-full">{{ product.reviewsCount }}&nbsp;review{{ product.reviewsCount > 1 ? 's' : '' }}</div>
				</div>
			</div>
		</div>
		<WishlistModal :show="showWishlistOptions" @update:show="showWishlistOptions = $event" :product="product" />
	</div>
</template>

<script>
import Swal from 'sweetalert2'
import Stars from '../partials/stars.vue'
import Modal from '../layout/modal.vue'
import Mango from '../../helpers/mango'
import WishlistModal from './wishlist-modal.vue'
import aa from 'search-insights'

export default {
	components: { Modal, Stars, WishlistModal },
	data() {
		return {
			showWishlistOptions: false,
			imageError: false,
			secondImageError: false,
		}
	},
	watch: {
		rawThumbnail() {
			this.imageError = false
		},
		rawSecondImage() {
			this.secondImageError = false
		},
	},
	emits: ['removeListItem'],
	inject: ['store'],
	props: {
		product: {
			type: Object,
			required: true,
		},
		wishlist: {
			type: Boolean,
			default: false,
		},
		birthKitItem: {
			type: Boolean,
			default: false,
		},
		publicList: {
			type: Boolean,
			default: false,
		},
		hideReviews: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		isUpsellItem: {
			type: Boolean,
			default: false,
		},
		queryID: {
			type: String,
			default: null,
		},
		searchResult: {
			type: Boolean,
			default: false,
		},
		position: {
			type: Number,
			default: null,
		},
		hidePrice: {
			type: Boolean,
			default: false,
		},
		clampName2: {
			type: Boolean,
			default: false,
		},
		clampName4: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		async handleProductAction(openBag) {
			if (this.isPriceHidden || this.showsAsOutOfStock) {
				this.$router.push(this.url)
				return
			}
			// Multi-variant / birth-kit products route to the product page (handled in addToBag); no confirm needed.
			if (this.birthKit || this.variants?.length > 1) {
				this.addToBag(openBag)
				return
			}
			// Quick-add of a product sold in increments: confirm the enforced quantity before adding to cart.
			if (this.purchaseIncrement > 1) {
				const result = await Swal.fire({
					title: 'Minimum purchase quantity',
					text: `This product can only be purchased in increments of ${this.purchaseIncrement}. Add ${this.purchaseIncrement} to your cart?`,
					icon: 'info',
					showCancelButton: true,
					confirmButtonText: `Add ${this.purchaseIncrement}`,
					cancelButtonText: 'Cancel',
					confirmButtonColor: '#e59789',
				})
				if (!result.isConfirmed) return
			}
			this.addToBag(openBag)
		},
		removeFromBag() {
			let existingItem = this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)
			if (!existingItem) return
			let quantity = existingItem.quantity
			if (quantity > this.purchaseIncrement) {
				existingItem.quantity -= this.purchaseIncrement
			} else {
				this.store.cart.cartItems = this.store.cart.cartItems.filter((c) => c.item.id !== this.product.id)
			}
		},
		addToBag(openBag) {
			if (this.isUpsellItem) {
				this.store.addingFromUpsell = true
			}
			if (this.birthKit || this.variants?.length > 1) {
				this.$router.push(this.url)
				return
			}

			if (this.product.outOfStock) return

			let existingItem = this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)
			if (existingItem) {
				existingItem.quantity += this.purchaseIncrement
			} else {
				this.store.cart?.cartItems?.push?.({
					item: this.product,
					quantity: this.purchaseIncrement,
					variant: this.variants?.[0],
					...(this.searchResult ? { queryID: this.queryID } : {}),
				})

				// GA4 Add to Cart Event
				if (typeof gtag === 'function') {
					const product = {
						id: this.product?.sku,
						name: this.product?.name,
						quantity: this.purchaseIncrement,
						google_business_vertical: 'retail',
						currency: 'USD',
						price: this.product?.currentPrice,
					}
					gtag('event', 'add_to_cart', {
						send_to: 'AW-387509916',
						ecomm_pagetype: 'cart',
						currency: 'USD',
						items: [product],
						value: product.price,
					})
				}

				// Algolia Add to Cart Event
				try {
					if (this.searchResult) {
						aa('addedToCartObjectIDsAfterSearch', {
							eventName: 'Product Added To Cart',
							index: 'InHisHands',
							objectIDs: [this.product.id],
							objectData: [
								{
									queryID: this.queryID,
									price: this.product.currentPrice,
									quantity: this.purchaseIncrement,
								},
							],
							currency: 'USD',
						})
					} else {
						aa('addedToCartObjectIDs', {
							eventName: 'Product Added To Cart',
							index: 'InHisHands',
							objectIDs: [this.product.id],
							objectData: [
								{
									price: this.product.currentPrice,
									quantity: this.purchaseIncrement,
								},
							],
							currency: 'USD',
							value: this.product.currentPrice,
						})
					}
				} catch (error) {
					console.error('Algolia Add to Cart Event Error', error)
				}
			}
			if (openBag === true && this.$route.path !== '/cart') this.store.showBag = true
		},
		removeFromKit() {
			let existingItem = this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)
			if (!existingItem) return
			let quantity = existingItem.quantity
			if (quantity > this.purchaseIncrement) {
				existingItem.quantity -= this.purchaseIncrement
			} else {
				this.store.editingKit.products = this.store.editingKit?.products.filter((c) => c.product.id !== this.product.id)
			}
		},
		addToKit(goToKit) {
			let existingItem = this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)
			if (existingItem) {
				existingItem.quantity += this.purchaseIncrement
			} else {
				this.store.editingKit?.products?.push?.({
					product: this.product,
					quantity: this.purchaseIncrement,
					variant: this.variants?.[0],
					optional: this.store.editingKit && !!this.store.birthKitOptional ? true : undefined,
				})
			}
			if (goToKit) this.$router.push(`/birthKits/${this.store.editingKit.id}/edit`)
		},
		removeListItem() {
			this.$emit('removeListItem')
		},
		addListItem() {
			this.showWishlistOptions = !this.showWishlistOptions
		},
	},
	computed: {
		isPriceHidden() {
			return !!(this.product?.isPriceHidden || this.product?.priceHiddenLabel)
		},
		showsAsOutOfStock() {
			if (this.isPriceHidden) return false
			return this.product?.outOfStock || this.variantsOutOfStock
		},
		addToCartButtonLabel() {
			if (this.birthKit) return 'View Kit'
			if (this.isPriceHidden) return 'View Details'
			if (this.variants.length > 1 && !this.product.outOfStock) return 'Choose Options'
			if (!this.product.outOfStock) return 'Add to Bag'
			return 'Out of Stock'
		},
		url() {
			if (this.searchResult) {
				return `/${this.product.collection || 'products'}/${this.product?.customUrl?.url?.replace('/', '')?.trim() || this.product.id}?queryID=${this.queryID}&searchResult=${this.searchResult}&position=${this.position}`
			}
			return `/${this.product.collection || 'products'}/${this.product?.customUrl?.url?.replace('/', '')?.trim() || this.product.id}?searchResult=${this.searchResult}`
		},
		birthKit() {
			return this.product?.collection == 'birthKits'
		},
		ihhBirthKit() {
			return this.product?.categories?.some((c) => c.name === 'Birth Kits by In His Hands')
		},
		variants() {
			return this.product?.variants || []
		},
		purchaseIncrement() {
			// Quick-add on the tile only applies to single-variant / no-variant products, so the
			// effective increment is the lone variant's (if any), then the product's, then 1.
			const variantInc = Number(this.variants?.[0]?.purchaseIncrement)
			if (Number.isFinite(variantInc) && variantInc > 0) return variantInc
			const productInc = Number(this.product?.purchaseIncrement)
			if (Number.isFinite(productInc) && productInc > 0) return productInc
			return 1
		},
		displayPrice() {
			const variantPrices = (this.product?.variants || [])
				.map((v) => v?.currentPrice ?? v?.calculatedPrice ?? v?.salePrice ?? v?.price)
				.filter((p) => typeof p === 'number' && !Number.isNaN(p))
			if (variantPrices.length) {
				return Math.min(...variantPrices)
			}
			const productPrice = this.product?.currentPrice
			return typeof productPrice === 'number' && !Number.isNaN(productPrice) ? productPrice : null
		},
		rawThumbnail() {
			return this.product?.image?.url || this.product?.images?.find((i) => i?.isThumbnail)?.thumbnail || this.product?.images?.find((i) => i?.isThumbnail)?.url || null
		},
		thumbnail() {
			if (!this.rawThumbnail || this.imageError) return '/images/obDefaultProductImage-min.jpg'
			return this.rawThumbnail
		},
		rawSecondImage() {
			const secondary = this.product?.images?.find((img) => img.sortOrder === 1)
			if (!secondary) {
				return (
					this.product?.images?.filter((i) => i.url != this.rawThumbnail)?.[0]?.thumbnail ||
					this.product?.images?.filter((i) => i.url != this.rawThumbnail)?.[0]?.url ||
					null
				)
			}
			return secondary?.thumbnail || secondary?.url || null
		},
		secondImage() {
			if (!this.rawSecondImage || this.secondImageError) return this.thumbnail
			return this.rawSecondImage
		},
		inCartQuantity() {
			return this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)?.quantity
		},
		inKitQuantity() {
			return this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)?.quantity
		},
		addToCartButtonClasses() {
			return [
				!this.birthKit && !this.store.editingKit?.id && this.showsAsOutOfStock ? 'bg-ihh-gray cursor-not-allowed' : 'bg-ihh-dark-salmon hover:bg-ihh-salmon',
				this.small ? 'w-full' : 'group-hover:-translate-y-10 mx-4',
			]
		},
		variantsOutOfStock() {
			return this.product?.variants?.every((v) => v.inventoryLevel <= 0) && this.product.inventoryTracking === 'variant'
		},
	},
}
</script>

<style></style>
